export const NAVBAR_BLOCK_s3 = {
  "blockType": "NAVBAR",
  "blockDesign": "NavDesign1",
  "editFormName": "NAVBAR_FORM_1",
  "styleProps": {
    "background-color": "#0F0F0F"
  },
  "logoType": "text",
  "logoImg": {
    "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
    "altText": "FlexBee",
    "styleProps": {
      "height": "3rem"
    }
  },
  "logoText": {
    "text": "💬 CODIC",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "logoHTML": {
    "html": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "links": [
    {
      "text": "ABOUT",
      "linkUrl": "/about",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "BLOG",
      "linkUrl": "/blog",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "PRICING",
      "linkUrl": "/pricing",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "GET STARTED",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "#333333",
        "border-width": "1px",
        "border-radius": "0.75rem",
        "padding": "14px 30px 14px 30px",
        "margin": "0px 0px 0px 120px",
        "border-color": "#4f4f4f",
        "background-color": "#ffffff"
      }
    }
  ],
  "hamburgerStyleProps": {
    "color": "#ffffff",
    "border-color": "#ffffff"
  },
  "metaDataId": 1746275388436,
  "afterIndex": 1,
  "blockId": 1746275388436,
  "linksStyleProps": {
    "color": "#ffffff",
    "padding": "14px 0px 14px 0px",
    "font-weight": "600"
  }
}